<p-toast position="top-center" key="contact" [baseZIndex]="15000"></p-toast>
<div class="innerBanner" (click)="imageClick(0)" style="background-image: url('{{ contactDetails.bannerImage }}')">
  <!-- <img
     [src]="contactDetails.bannerImage ? contactDetails.bannerImage : '../../../assets/images/NoImage.jpg'"
     style="width: 100%"
   /> -->
  <div class="bannerText"></div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
  <!-- <ng-template pTemplate="thumbnail" let-item>
    <div class="grid grid-nogutter justify-content-center">
      <img [src]="highLights.bannerImage" style="display: block" />
    </div>
  </ng-template> -->
</p-galleria>

<div class="container">
  <div class="contentPanel">
    <!-- <app-breadcrumb></app-breadcrumb> -->
    <app-breadcrumb-row></app-breadcrumb-row>
    <div class="pageTitle">
      <h1>{{ contactDetails.bannerTitle }}</h1>
      <p [innerHTML]="contactDetails.content"></p>
    </div>
  </div>
  <form [formGroup]="basicDetailsForm" class="basicDetailsForm">
    <div class="row">
      <div class="col-md-4">
        <label for="name">{{ 'Name' | translate }}<span class="info-required">*</span></label>

        <input pInputText id="name" class="form-control" formControlName="name" name="name" required />
        <span
          class="err-msginfo error-message-clr"
          *ngIf="
            !basicDetailsForm.controls['name'].valid &&
            (basicDetailsForm.controls['name'].dirty || basicDetailsForm.controls['name'].touched)
          "
          >{{ 'Require Name' | translate }}</span
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label for="email">{{ 'Email' | translate }}<span class="info-required">*</span></label>

        <input
          pInputText
          id="email"
          class="form-control"
          formControlName="email"
          pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
          required
        />
        <span
          class="err-msginfo error-message-clr"
          *ngIf="
            !basicDetailsForm.controls['email'].valid &&
            (basicDetailsForm.controls['email'].dirty || basicDetailsForm.controls['email'].touched)
          "
        >
          <span *ngIf="basicDetailsForm.controls['email'].errors?.required">{{ 'Require Email' | translate }}</span>
          <span *ngIf="basicDetailsForm.controls['email'].errors?.pattern">{{ 'Valid Email' | translate }}</span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label for="subject">{{ 'Subject' | translate }}<span class="info-required">*</span></label>

        <input pInputText id="subject" class="form-control" formControlName="subject" required [maxlength]="300" />
        <span
          class="err-msginfo error-message-clr"
          *ngIf="
            !basicDetailsForm.controls['subject'].valid &&
            (basicDetailsForm.controls['subject'].dirty || basicDetailsForm.controls['subject'].touched)
          "
          >{{ 'Require Subject' | translate }}</span
        >
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <label for="message">{{ 'Message' | translate }}<span class="info-required">*</span></label>

        <textarea
          pInputTextarea
          id="message"
          class="form-control"
          maxlength="300"
          formControlName="message"
          required
          placeholder="{{ 'MAX char' | translate }}"
        ></textarea>
        <span
          class="err-msginfo error-message-clr"
          *ngIf="
            !basicDetailsForm.controls['message'].valid &&
            (basicDetailsForm.controls['message'].dirty || basicDetailsForm.controls['message'].touched)
          "
          >{{ 'Require Message' | translate }}</span
        >
      </div>
    </div>
    <div class="row" *ngIf="recaptcha != undefined || recaptcha != null">
      <div class="col-md-4">
        <label for="message">{{ 'Verify Request' | translate }}<span class="info-required">*</span></label>
      </div>
    </div>
    <div class="row" *ngIf="recaptcha != undefined || recaptcha != null">
      <!-- <div class="col-md-5" *ngIf="recaptcha.render">
        <p-captcha siteKey="6LfrFKQUAAAAAMzFobDZ7ZWy982lDxeps8cd1I2i" (onResponse)="showResponse($event)"></p-captcha>
      </div> -->
      <ng-container *ngIf="recaptcha.render">
        <p-captcha
          siteKey="6LfrFKQUAAAAAMzFobDZ7ZWy982lDxeps8cd1I2i"
          (onExpire)="resetCaptchaResponse()"
          (onResponse)="showResponse($event)"
        ></p-captcha>
      </ng-container>
    </div>

    <div class="row">
      <div class="col-md-5">
        <input type="checkbox" id="authorize" formControlName="authorization" required style="vertical-align: middle" />
        <label for="authorize" style="font-size: 13px"
          >{{ 'Authorize Contact' | translate }}<span class="info-required">*</span></label
        >
        <!-- <textarea pInputTextarea id="message" class="form-control" formControlName="message" required></textarea> -->
        <span
          class="err-msginfo error-message-clr"
          *ngIf="
            !basicDetailsForm.controls['authorization'].valid &&
            (basicDetailsForm.controls['authorization'].dirty || basicDetailsForm.controls['authorization'].touched)
          "
          >{{ 'Require Authoriation' | translate }}</span
        >
      </div>
    </div>

    <button
      type="submit"
      pButton
      icon="fa fa-check"
      class="btn btn-primary contact"
      (click)="saveContactDetails()"
      [disabled]="basicDetailsForm.invalid || !isCaptcha"
      label="{{ 'Send' | translate }}"
    ></button>
  </form>

  <p>
    {{ 'Please' | translate }}
    <a href="/app-frequentlyquestions"
      >{{ 'click here' | translate }}<span class="faq-plain"> {{ 'For FAQ' | translate }}</span></a
    >
  </p>
</div>
